<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div *ngIf="!reportQueqe" style="width:100%; position:absolute; top:0px; height: 65px;left: 0px">        
        <overlay-header [showCloseButton]="true" (closeClick)="closeClick()">
            Reports Queue
        </overlay-header>
    </div>
    <!-- containt -->
    <div id="divReportsQueue" class="sis-app-content-withfooter"
        style="height:95%; overflow:hidden; background-color: #ffffff;" [ngStyle]="{'width': gridWidth +'%' }">
        <h3 class="sis-app-header-label" style="text-align:right;">Report Queue</h3>
        <div style="display: flex; flex-direction: row;justify-content: flex-end;align-items: top;">
            <tyl-form-field label='Site'>
                <mat-select id='ddlSite' [(ngModel)]='selectedSchool' name='Site' (selectionChange)="schoolChange()">
                    <mat-option *ngFor='let school of schools' [value]='school'>{{school.SchoolName}}</mat-option>
                </mat-select>
            </tyl-form-field>
            <tyl-form-field label='Year' style="padding-left: 10px;">
                <mat-select id='ddlYear' [(ngModel)]='selectedYear' name='Year' (selectionChange)="yearChange()">
                    <mat-option *ngFor='let year of years' [value]='year'>{{year.Description}}</mat-option>
                </mat-select>
            </tyl-form-field>

            <div style="padding-top: 5px;display: flex;flex-direction: column;">
                <button mat-stroked-button (click)="searchClick()" style="padding-left: 10px;" translate>
                    Search
                </button>
            </div>
        </div>
        <div style="overflow:auto; height:100%;" [ngStyle]="{'height': gridHeight + 'px'}" class="print-kedo-pdf">
            <!-- Table -->
            <mat-table #table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="RunDate"
                matSortDisableClear matSortDirection="desc">
                <ng-container matColumnDef="CheckBox">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;">
                        <tyl-checkbox [(checked)]="checkedAll" id="chkcheckedAll" [indeterminate]="checkIndeterminate"
                            (change)="checkAll()">
                        </tyl-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report"
                        style="min-width:68px;max-width:68px;text-align:center;color:black;">
                        <tyl-checkbox id="chkSelected{{report.Id}}" [(checked)]="report.Selected"
                            (change)="setAllCheckbox()">
                        </tyl-checkbox>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="ReportName">
                    <mat-header-cell *matHeaderCellDef style="min-width:250px;max-width:300px;">
                        Report
                        <filter [data]="angularMatData" columnName="ReportName" dataType="string" id="ReportFilter"
                            class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report" style="min-width:250px;max-width:300px;">
                        <a *ngIf="report.ReportStatus === 'Completed'" (click)="saveFile(report)"
                            style="white-space: nowrap">{{report.ReportName}}</a>
                        <span *ngIf="report.ReportStatus !== 'Completed'"
                            style="white-space: nowrap">{{report.ReportName}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="SISCode">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="SISCode"
                        style="min-width:100px;max-width:100px;text-align:center;padding-left: 10px;">
                        Site
                        <filter [data]="angularMatData" columnName="SISCode" dataType="string" id="SISCodeFilter"
                            class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report"
                        style="min-width:100px;max-width:100px;text-align:center;padding-left: 10px;">
                        {{report.SISCode}}
                    </mat-cell>
                </ng-container>
                <!-- Year -->
                <ng-container matColumnDef="Term">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Term"
                        style="min-width:100px;max-width:100px;text-align:center;">
                        Year
                        <filter [data]="angularMatData" columnName="Term" dataType="string" id="TermFilter"
                            class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report" style="min-width:100px;max-width:100px;text-align:center;">
                        {{report.Term}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="UserName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="UserName">
                        User
                        <filter [data]="angularMatData" columnName="UserName" dataType="string" id="UserNameFilter"
                            class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report">
                        {{report.UserName}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="RunDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="RunDate">
                        Run
                        <filter [data]="angularMatData" columnName="RunDate" dataType="date" id="RunDateFilter"
                            class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report">
                        {{report.RunDate | date:'MM/dd/yy h:mm a'}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="ReportStatus">
                    <mat-header-cell *matHeaderCellDef>
                        Status
                        <filter [data]="angularMatData" columnName="ReportStatus" dataType="string"
                            id="ReportStatusFilter" class="mat-filter">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let report">
                        {{report.ReportStatus}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                    <mat-cell *matCellDef="let report">
                        <a (click)="deleteReportQueue(report)" style="white-space: nowrap">Delete</a>
                    </mat-cell>
                </ng-container>
                <!-- Header row -->
                <mat-header-row *matHeaderRowDef="columnsToDisplay;">
                </mat-header-row>
                <!-- Data rows -->
                <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" tabindex="0"
                    style="padding:0px;" matRipple>
                </mat-row>
            </mat-table>
        </div>
        <!-- Table Paginator -->
        <mat-paginator [pageSizeOptions]="pageSizes" [pageSize]="initialPageSize" showFirstLastButtons></mat-paginator>
    </div>
</tyl-kendo-pdf-export>
<!-- footer -->
<div class="sis-app-footer" style="align-items: center;" [ngStyle]="{'width': gridWidth +'%' }">
    <mat-dialog-actions>
        <div class="flex-footer-left" style="align-items: center; width: 50%;">
            <tyl-button style="float:left;" image="trash.png" disabledImage="trash disabled.png"
                (clickEvent)="deleteSelected()" [disabled]="selectedReportQueue && selectedReportQueue.length < 1"
                label="Delete Selected" translate>
            </tyl-button>
            <tyl-button id="btnFilter" image="filter.png" label="Filter" (clickEvent)="openFilter();"
                *ngIf="!isDataFiltered">
            </tyl-button>
            <tyl-button id="btnFilterYellow" image="filter yellow.png" label="Filter" (clickEvent)="openFilter();"
                *ngIf="isDataFiltered"></tyl-button>
            <!-- <tyl-button style="float:left;" *ngIf="!reportQueqe" image="previous arrow.png" label="Report List"
                translate (clickEvent)="reportList()">
            </tyl-button> -->
        </div>
        <div class="flex-footer-middle" style="align-items: center">
            <tyl-button id="studentInfoCloseButton" image="Print.png" label="Print" (clickEvent)="printClick()">
            </tyl-button>
            <filter-notification [filtered]="isFiltered || angularMatData.isFiltered()" (clearFilter)="clearFilter()">
            </filter-notification>
        </div>
        <div class="flex-footer-right" style="align-items: center; width: 50%;">
            <tyl-checkbox id='chkShowAllUsers' [(checked)]='ShowAllUsers' *ngIf="userName === 'SDMADMIN'"
                (change)="formChanged()">
                Show all users
            </tyl-checkbox>
            <tyl-checkbox id='chkShowCompleted' [(checked)]='ShowCompleted' *ngIf="userName === 'SDMADMIN'"
                (change)="formChanged()">
                Show Completed
            </tyl-checkbox>
            <tyl-button style="float:right;" image="refresh.png" translate label="Refresh Page"
                (clickEvent)="refreshPage()">
            </tyl-button>
            <!-- <tyl-button style="float:right;" image="cancel.png" translate label="Close" (clickEvent)="closeClick()">
            </tyl-button> -->
        </div>
    </mat-dialog-actions>
</div>
<div *ngIf="showFilter" style="background-color:#ffffff;
        display:flex;
        flex-direction:column;
        position: absolute;
        transition:opacity 1.5s;
        top:52px;
        right: 0px;
        opacity: 1;
       -webkit-transition: opacity 0.5s;
        border:thin solid gray;
         max-width: 16%; min-width: 16%;" [ngStyle]="{'height': (gridHeight < 700 ? 92 +'%' : 95+'%') }">
    <div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;flex:.05">
        Filter
    </div>
    <div style="display: flex; flex-direction: column; overflow: auto;flex-grow: 1;padding: 0px 10px;">
        <div>
            <tyl-form-field style="margin-left: 5px;" label="Report">
                <input matInput id='inpReportName' type='text' [(ngModel)]='filter.ReportName'
                    (ngModelChange)="applyFilter();" />
            </tyl-form-field>
        </div>
        <div>
            <tyl-form-field style="margin-left: 5px;" label="Site">
                <input matInput id='inpSite' type='text' [(ngModel)]='filter.SISCode'
                    (ngModelChange)="applyFilter();" />
            </tyl-form-field>
        </div>
        <div>
            <tyl-form-field style="margin-left: 5px;" label="User" *ngIf="ShowAllUsers">
                <input matInput id='inpUser' type='text' [(ngModel)]='filter.UserName'
                    (ngModelChange)="applyFilter();" />
            </tyl-form-field>
        </div>
        <div>
            <tyl-datepicker style="margin-left: 5px;" label="Start Date" id="filterStartDateField"
                [value]="filter.startDate" (valueChange)="filter.startDate = $event; applyFilter();"></tyl-datepicker>
        </div>
        <div>
            <tyl-datepicker style="margin-left: 5px;" label="End Date" id="filterEndDateField" [value]="filter.endDate"
                (valueChange)="filter.endDate = $event; applyFilter();"></tyl-datepicker>
        </div>
        <div>
            <label style="margin-left: 5px;">Status</label>
            <div>
                <tyl-checkbox style="margin-left: 5px;" id="chkSubmitted" [(checked)]="filter.Submitted"
                    (change)="applyFilter();">
                    Submitted
                </tyl-checkbox>
            </div>
            <div>
                <tyl-checkbox style="margin-left: 5px;" id="chkRunning" [(checked)]="filter.Running"
                    (change)="applyFilter();">
                    Running
                </tyl-checkbox>
            </div>
            <div>
                <tyl-checkbox style="margin-left: 5px;" id="chkCompleted" [(checked)]="filter.Completed"
                    (change)="applyFilter();">
                    Completed
                </tyl-checkbox>
            </div>
            <div>
                <tyl-checkbox style="margin-left: 5px;" id="chkErrorStatus" [(checked)]="filter.ErrorStatus"
                    (change)="applyFilter();">
                    Error
                </tyl-checkbox>
            </div>
        </div>
    </div>
    <div class="flex-footer">
        <!-- Left Buttons -->
        <div class="footerLeft">
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>
        </div>
        <!-- Right Buttons -->
        <div class="footerRight">
            <tyl-button image="Checkmark.png" label="Save" (clickEvent)="saveFilter()"></tyl-button>
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
        </div>
    </div>
</div>